export const userOrigin = (process.env.VUE_APP_USER_ORIGIN || '').trim().replace(/\/+$/, '');

export function isUserSite() {
    return Boolean(userOrigin) && window.location.origin === userOrigin;
}

export function userLoginPath() {
    const whiteLabel = localStorage.getItem('end_user_wl') || '';
    return whiteLabel.trim()
        ? `/user-login/${encodeURIComponent(whiteLabel)}`
        : '/user-login';
}
